import { useEffect, useState } from 'react';
import { Box, Typography, Button, IconButton } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { ChevronRight } from '@mui/icons-material';
import { useNavigate, useParams } from 'react-router-dom';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import { Layout, Loading, UserNavbar } from '../../../../../../components';
import { getEventsByVenue } from './api/venue-transactions-actions';
import CardEvent from '../../../components/CardEvent/CardEvent';
import { formatDate, formatTime } from '../../../../../../utils';

export default function VenueTransactionsEvent() {
  const [loading, setLoading] = useState(false);
  const [events, setEvents] = useState([]);

  const { venueId } = useParams();
  const navigate = useNavigate();

  const getEvents = async (venueIdParam) => {
    setLoading(true);
    const response = await getEventsByVenue({
      idVenue: venueIdParam || 0,
      ingonreUnlisted: true,
    });
    if (response) setEvents(response);
    setLoading(false);
  };

  useEffect(() => {
    getEvents(venueId);
  }, [venueId]);

  const getFormattedDate = (event) => formatDate(event?.parameters_event?.event_date);

  const getFormattedTime = (event) =>
    `${formatTime(event?.parameters_event?.hour_start_event, 'hA')} - ${formatTime(
      event?.parameters_event?.hour_end_event,
      // eslint-disable-next-line prettier/prettier
      'hA'
    )}`;

  return (
    <Layout>
      <UserNavbar />
      {loading && <Loading />}
      <Grid container justifyContent="center" marginTop={10}>
        <Grid item style={{ width: '100%' }}>
          <IconButton onClick={() => navigate(-1)}>
            <ArrowBackRoundedIcon />
          </IconButton>
        </Grid>
      </Grid>
      <Grid container justifyContent="center">
        <Grid item xs={9} marginBottom={3}>
          <Typography variant="h3" color="#EE7B57" fontWeight="bold" marginTop={4}>
            Venue Events
          </Typography>
        </Grid>
      </Grid>
      <Grid container justifyContent="center" padding={4} spacing={4}>
        {events.length === 0 && (
          <Grid item>
            <Typography variant="h6">No events found</Typography>
          </Grid>
        )}
        {events.map((event) => (
          <Grid size={3} key={event.id}>
            <CardEvent
              title={event?.name}
              image={event?.photo}
              caption={<span>{event?.venue?.name}</span>}
              status={event?.status}
              cardFooter={
                <div>
                  <div>
                    <Button
                      onClick={() =>
                        navigate(`/app/dashboard/venue-transactions/${venueId}/event/${event.id}`)
                      }
                      sx={{ color: '#EE7B57', textTransform: 'none' }}>
                      See transactions <ChevronRight sx={{ fill: '#EE7B57' }} />
                    </Button>
                  </div>
                </div>
              }>
              <Box>
                <Typography gutterBottom variant="caption" color="text.secondary">
                  {getFormattedDate(event)}, {getFormattedTime(event)}
                </Typography>
              </Box>
            </CardEvent>
          </Grid>
        ))}
      </Grid>
    </Layout>
  );
}
